import React from "react";
import { Button } from "@mui/joy";

interface CameraPreviewProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
  cameraError: string | null;
  onClose: () => void;
}

const CameraPreview: React.FC<CameraPreviewProps> = ({
  videoRef,
  cameraError,
  onClose,
}) => {
  if (cameraError) {
    return (
      <div className="absolute inset-0 flex items-center justify-center flex-col p-4 text-white">
        <div className="bg-red-600 p-4 rounded-lg text-center mb-4">
          <p className="font-medium text-lg mb-2">Camera Error</p>
          <p>{cameraError}</p>
        </div>
        <Button
          variant="outlined"
          color="neutral"
          onClick={onClose}
          className="mt-4 bg-white text-black hover:bg-gray-200"
        >
          Close Camera
        </Button>
      </div>
    );
  }

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      className="w-full h-full object-cover transform scale-x-[-1]"
      style={{ objectFit: "cover" }}
      x-webkit-airplay="allow"
      webkit-playsinline="true"
    />
  );
};

export default CameraPreview;
